// File: clientapp/src/pages/SecurityGroups.js
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
    Tooltip,
    TextField,
    TablePagination,
    Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function SecurityGroups() {
    const [groups, setGroups] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const navigate = useNavigate();

    useEffect(() => {
        fetchGroups();
    }, []);

    async function fetchGroups() {
        try {
            const response = await fetch('/api/security/groups', {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                setGroups(data);
            }
        } catch (err) {
            console.error(err);
        }
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this group?")) {
            try {
                const response = await fetch(`/api/security/groups/${id}`, {
                    method: 'DELETE',
                    credentials: 'include'
                });
                if (response.ok) {
                    fetchGroups();
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredGroups = groups.filter(g =>
        g.name.toLowerCase().includes(filterText.toLowerCase())
    );
    const paginatedGroups = filteredGroups.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Container>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">Manage Groups</Typography>
                <Tooltip title="Create New Group">
                    <IconButton color="primary" component={Link} to="/security/groups/new">
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box mb={2}>
                <TextField
                    label="Search Groups"
                    variant="outlined"
                    size="small"
                    value={filterText}
                    onChange={e => {
                        setFilterText(e.target.value);
                        setPage(0);
                    }}
                    fullWidth
                />
            </Box>
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Group Name</TableCell>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Description</TableCell>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Actions</TableCell>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Detail</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedGroups.map(group => (
                            <TableRow key={group.groupId}>
                                <TableCell>{group.name}</TableCell>
                                <TableCell>{group.description}</TableCell>
                                <TableCell>
                                    <Tooltip title="Delete Group">
                                        <IconButton size="small" onClick={() => handleDelete(group.groupId)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell>
                                    <Tooltip title="View Details / Edit">
                                        <IconButton size="small" component={Link} to={`/security/groups/${group.groupId}`}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={filteredGroups.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 20, 50]}
                />
            </Paper>
        </Container>
    );
}
